/** Tiny Web Audio beeps. Fail quietly if the browser blocks audio until a gesture. */

let context: AudioContext | null = null;

function getContext(): AudioContext | null {
  const Ctor = window.AudioContext ?? (window as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  context ??= new Ctor();
  if (context.state === "suspended") void context.resume();
  return context;
}

function tone(frequency: number, duration: number, type: OscillatorType, gain: number) {
  const audio = getContext();
  if (!audio) return;
  const oscillator = audio.createOscillator();
  const amp = audio.createGain();
  oscillator.type = type;
  oscillator.frequency.value = frequency;
  amp.gain.setValueAtTime(gain, audio.currentTime);
  amp.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + duration);
  oscillator.connect(amp);
  amp.connect(audio.destination);
  oscillator.start();
  oscillator.stop(audio.currentTime + duration);
}

export function playKoloSpinSound() {
  tone(220, 0.18, "triangle", 0.08);
}

export function playKoloWinSound() {
  tone(523, 0.12, "sine", 0.1);
  window.setTimeout(() => tone(784, 0.18, "sine", 0.09), 90);
}
